import { ProviderDataReviewType } from '../enums/provider-data-review-type.enum';
import { keyBy } from 'lodash-es';

export const ProviderDataReviewTypeOptions = [
  { value: ProviderDataReviewType.providerSpecialtyDataReview, display: 'Specialty Data Review' },
  { value: ProviderDataReviewType.providerFaxNumberDataReview, display: 'Fax Number Data Review' },
];

export const keyedProviderDataReviewTypeOptions = keyBy(ProviderDataReviewTypeOptions, 'value');